import { render, staticRenderFns } from "./DreamFactRoom.vue?vue&type=template&id=b122f6aa&"
import script from "./DreamFactRoom.vue?vue&type=script&lang=js&"
export * from "./DreamFactRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports